"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _ReactGallery = _interopRequireDefault(require("@micado-digital/react-gallery/ReactGallery02"));
var _FallbackImage = _interopRequireDefault(require("@micado-digital/react-ui/components/FallbackImage"));
var _useImages = _interopRequireDefault(require("../../../ProductDetail/hooks/useImages"));
var _Gallery = _interopRequireDefault(require("./Gallery.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Gallery = _ref => {
  let {
    mediaFormats,
    thumbsMediaFormat = "product-detail-thumb"
  } = _ref;
  const {
    items = [],
    _loading = false
  } = (0, _useImages.default)();
  const css = (0, _Gallery.default)();
  const elements = (0, _react.useMemo)(() => {
    var _items$map;
    return (_items$map = items === null || items === void 0 ? void 0 : items.map((image, index) => ({
      id: index,
      media: image
    }))) !== null && _items$map !== void 0 ? _items$map : [];
  }, [items]);
  if (_loading) return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.gallery, "mco-shop-product-detail-gallery")
  }, !(0, _isEmpty.default)(elements) ? /*#__PURE__*/_react.default.createElement(_ReactGallery.default, {
    absoluteMediaURLs: true,
    elements: elements,
    mediaFormats: mediaFormats,
    navNext: "/img/icons/chevron-right.svg",
    navPrev: "/img/icons/chevron-left.svg",
    thumbs: thumbsMediaFormat,
    webpFallback: false
  }) : /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.fallbackImage, "mco-shop-product-detail-gallery__fallback-image")
  }, /*#__PURE__*/_react.default.createElement(_FallbackImage.default, null))));
};
Gallery.propTypes = {
  mediaFormats: _propTypes.default.object,
  thumbsMediaFormat: _propTypes.default.string
};
var _default = exports.default = Gallery;